<!--模板界面-->
<template>
	<div class="bg">
		<p class="titleText">站点概况</p>
		<img src="../../../../public/static/杭州东杰定制/看板/站点概况/titleBottom.png" style="margin: 10px 0;width: 100%;">
		<div class="flexBetween" style="padding: 0 10px;">
			<div class="boxBg flexCenter">
				<img src="../../../../public/static/杭州东杰定制/看板/站点概况/user.png">
				<div>
					<p>单位数</p>
					<p class="value">{{unitCount}} <span>个</span> </p>
				</div>
			</div>
			<div class="boxBg flexCenter">
				<img src="../../../../public/static/杭州东杰定制/看板/站点概况/zaixianlv.png">
				<div>
					<p>在线率</p>
					<p class="value">100 <span>%</span> </p>
				</div>
			</div>
		</div>
		<div class="flexBetween" style="margin-top: 10px;padding: 0 10px;">
			<div class="boxBg flexCenter">
				<img src="../../../../public/static/杭州东杰定制/看板/站点概况/byq.png">
				<div>
					<p>变压器</p>
					<p class="value">{{loadDeviceCount}} <span>台</span> </p>
				</div>
			</div>
			<div class="boxBg flexCenter">
				<img src="../../../../public/static/杭州东杰定制/看板/站点概况/rongliang.png">
				<div>
					<p>总容量</p>
					<p class="value">{{loadCapacity}} <span>kVA</span> </p>
				</div>
			</div>
		</div>
		<vchart style="height: calc(100% - 67px - 67px - 40px);" ref='vchartBar' themes="dongjieEchart"></vchart>
	</div>
</template>

<script>
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			vchart
		},
		props: {},
		data() {
			return {
				barOption: {
					xAxis: [{
						type: 'category',
						data: [],
						show:true
					}],
					yAxis: [{
						title: '能耗值（KWH）',
						type: 'value',
						show:false
					}],
					legend: {
						show:false
					},
					tooltip: {
						trigger: 'axis',
					},
					grid: {
						height: '80%',
						left: '0',
						right: '0',
						bottom: '10%',
						containLabel: true
					},
					series: [{
						name: '用户数',
						type: 'bar',
						barWidth:30,
						label:{
							show:true,
							position:'top'
						},
						data: []
					}],
				},
			}
		},
		created() {},
		mounted() {
			debugPage = this
			var axios = require('axios')
			axios({
				url: "/static/杭州东杰定制/看板/地图/info.json",
			}).then(respon => {
				var data = JSON.parse(JSON.stringify(respon.data))
				var areaUserCount = data.areaUserCount
				var keyList = []
				var valueList=[]
				eachObject(areaUserCount, (item, key) => {
					keyList.push(key.substring(0,key.length-2))
					valueList.push([key.substring(0,key.length-2),item])
				})
				this.barOption.xAxis[0].data = keyList
				this.barOption.legend.data = keyList
				this.barOption.series[0].data = valueList
				this.$refs.vchartBar.setData(this.barOption,true)
			})
			this.$refs.vchartBar.setData(this.barOption)
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			unitCount() {
				//一共有多少个下级单位
				var count = 0
				filterTreeRecursive([this.nowUnit], item => {
					if (item.entityName == "UsePowerUnit" && item.id != this.nowUnit.id) {
						count++
					}
					return true
				})
				return count
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			loadCapacity() {
				//总负荷容量
				return this.$store.unitStore.getters.getLoadCount(this.nowUnit.id)
			},
			loadDeviceCount(){
				return this.$store.unitStore.getters.getLoadDeviceList(this.nowUnit.id).length
			},
		},
		watch: {},
		methods: {

		}
	}
</script>

<style scoped>
	.boxBg {
		width: calc(50% - 5px);
		padding: 15px 0;
		background-image: url(../../../../public/static/杭州东杰定制/看板/站点概况/boxBg.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}

	.boxBg>img {
		margin-right: 5px;
		width: 36px;
		height: 36px;
	}

	.boxBg>div {
		width: calc(100% - 55px);
	}

	.boxBg>div>p:first-of-type {
		font-size: 12px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.boxBg p.value {
		color: #f46314;
		font-size: 16px;
		font-weight: bold;
		margin-top: 5px;
	}

	.bottomImg {
		width: 80%;
		margin: 15% 10% 0 10%;
	}
</style>
